var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 1.96875C17.4062 3.65625 17.5 6.65625 15.75 8.46875L9.6875 14.7188C9.3125 15.125 8.65625 15.125 8.28125 14.7188L2.21875 8.46875C0.46875 6.65625 0.5625 3.65625 2.53125 1.96875C4.25 0.5 6.8125 0.78125 8.375 2.40625L9 3.03125L9.59375 2.40625C11.1875 0.78125 13.7188 0.5 15.4375 1.96875Z",
    fill: "#FA0B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.bc18e99074c5a4e52c78cb90569f902d.svg";
export { ForwardRef as ReactComponent };